import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './store/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AdminRoute } from './components/AdminRoute'
import { Layout } from './components/Layout'
import { ToastProvider } from './components/Toast'

// Pages
import LoginPage from './pages/Login/LoginPage'
import DashboardPage from './pages/Dashboard/DashboardPage'
import AssessmentPage from './pages/Assessment/AssessmentPage'
import RankingPage from './pages/Ranking/RankingPage'
import HistoryPage from './pages/History/HistoryPage'
import CyclingPage from './pages/Cycling/CyclingPage'
import AuditPage from './pages/Audit/AuditPage'
import ProfilePage from './pages/Profile/ProfilePage'
import NotFoundPage from './pages/NotFound/NotFoundPage'
// import ComingSoonPage from './pages/ComingSoon/ComingSoonPage'
import EmployeesPage from './pages/Employees/EmployeesPage'
import EmployeeDetailPage from './pages/Employees/EmployeeDetailPage'
import CompaniesPage from './pages/Companies/CompaniesPage'
import CompanyDashboardPage from './pages/Companies/CompanyDashboardPage'
import GroupsPage from './pages/Groups/GroupsPage'
import UsersPage from './pages/Users/UsersPage'
import ForgotPasswordPage from './pages/ForgotPassword/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPassword/ResetPasswordPage'
import SelfAssessmentPage from './pages/SelfAssessment/SelfAssessmentPage'
import ApprovalsPage from './pages/Approvals/ApprovalsPage'
import OwnershipRulesPage from './pages/Rules/OwnershipRulesPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
            <Route path="/redefinir-senha" element={<ResetPasswordPage />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <DashboardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/minha-avaliacao"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SelfAssessmentPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/avaliar"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AssessmentPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/aprovacoes"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <ApprovalsPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/ranking"
              element={
                <ProtectedRoute>
                  <Layout>
                    <RankingPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/historico"
              element={
                <ProtectedRoute>
                  <Layout>
                    <HistoryPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/regras"
              element={
                <ProtectedRoute>
                  <Layout>
                    <OwnershipRulesPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/perfil"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProfilePage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/funcionarios"
              element={
                <ProtectedRoute>
                  <Layout>
                    <EmployeesPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/funcionarios/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <EmployeeDetailPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/empresas"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <CompaniesPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/empresas/:id/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CompanyDashboardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/usuarios"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <UsersPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/grupos"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <GroupsPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/ciclagem"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <CyclingPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/auditoria"
              element={
                <ProtectedRoute>
                  <AdminRoute>
                    <Layout>
                      <AuditPage />
                    </Layout>
                  </AdminRoute>
                </ProtectedRoute>
              }
            />

            {/* 404 */}
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  )
}

export default App
